window.portalModule.controller 'ConfirmedCancellationRequestedInfoModalController', ($scope, $log, $timeout, $uibModalInstance, feedItem, InfoModalService) ->
  $log = $log.getInstance('ConfirmedCancellationRequestedInfoModalController')
  $log.log 'confirmed cancellation requested info modal controller loaded.'

  # Variables
  # -----------------------------------

  $scope.feedItem = feedItem.data
  $log.log 'feedItem', $scope.feedItem
  $scope.headerText = 'Canceled appointment'
  $scope.subject = 'Appointment:'
  $scope.subjectStatus = 'Per your request'

  # if requires_provider_authorization
  if $scope.feedItem.charges_may_apply
    $scope.headerText = 'Your cancellation request'
    $scope.subject = 'Original appointment:'
    $scope.subjectStatus = 'Awaiting response from doctor\'s office'

  # Setup
  # -----------------------------------
  # this service determines the default background state to load if a modal doesn't have one (page refresh)
  # in that case it also determines where to tranition to when the user closes the modal
  InfoModalService.setup($scope.feedItem)

  # Actions
  # -----------------------------------
  $scope.close = ->
    $log.log 'cancel called'
    $uibModalInstance.dismiss "cancel"

  # when you click outside the modal go to the parent state
  $uibModalInstance.result.finally (response) ->
    InfoModalService.transitionAway()

  # Transistion away if the feedItem is in the incorrect state
  $uibModalInstance.rendered.finally (response) ->
    unless $scope.feedItem.record_state == 'confirmed_cancellation_requested'
      $uibModalInstance.dismiss "cancel"